// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10rTJ","colBig":"styles_colBig__2acl3","colSmall":"styles_colSmall__2i_aT"};